import { Badge, TableColumn } from '@ibsys/kit';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { C1ToAsrCallItem } from '@/entities/integrations';

/**
 * Колонки таблицы отобранных звонков интеграции c1-to-asr.
 */
export const useC1ToAsrCallColumns = (): TableColumn<C1ToAsrCallItem>[] => {
  const { t } = useTranslation(['integrations']);

  return useMemo(
    () => [
      {
        accessorKey: 'id',
        header: () => <span>{t('integrations:c1ToAsr.table.id')}</span>,
        size: 90,
        cell: ({ row }) => <span className="text-sm">{row.original.id}</span>,
      },
      {
        accessorKey: 'startedAt',
        header: () => <span>{t('integrations:c1ToAsr.table.startedAt')}</span>,
        size: 180,
        cell: ({ row }) => (
          <span className="text-sm">
            {row.original.startedAt ? new Date(row.original.startedAt).toLocaleString() : ''}
          </span>
        ),
      },
      {
        accessorKey: 'finishedAt',
        header: () => <span>{t('integrations:c1ToAsr.table.finishedAt')}</span>,
        size: 180,
        cell: ({ row }) => (
          <span className="text-sm">
            {row.original.finishedAt ? new Date(row.original.finishedAt).toLocaleString() : ''}
          </span>
        ),
      },
      {
        accessorKey: 'line',
        header: () => <span>{t('integrations:c1ToAsr.table.line')}</span>,
        size: 140,
        cell: ({ row }) => <span className="text-sm">{row.original.line ?? ''}</span>,
      },
      {
        accessorKey: 'hasAudio',
        header: () => <span>{t('integrations:c1ToAsr.table.hasAudio')}</span>,
        size: 180,
        cell: ({ row }) => (
          <Badge variant={row.original.hasAudio ? 'primary' : 'secondary'}>
            {row.original.hasAudio
              ? t('integrations:c1ToAsr.table.audioAttached')
              : t('integrations:c1ToAsr.table.audioPending')}
          </Badge>
        ),
      },
      {
        accessorKey: 'hasTranscription',
        header: () => <span>{t('integrations:c1ToAsr.table.hasTranscription')}</span>,
        size: 140,
        cell: ({ row }) => (
          <Badge variant={row.original.hasTranscription ? 'primary' : 'secondary'}>
            {row.original.hasTranscription ? t('integrations:c1ToAsr.table.yes') : t('integrations:c1ToAsr.table.no')}
          </Badge>
        ),
      },
    ],
    [t],
  );
};
